import React, { Component, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom';
import Configdata from './Defaultdata';
import Usersession from './Usersession';
import Guseritem from './Guetitem';
import axios from 'axios';

export default class Useritems extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "profilepic";
	
  	}
	
    state = {

	
        name: "",
       respdata: null,   
       url: "",
     
      uset:{pfpid:0,age:0,utf:true,uname:'',points:0},
      isf:true,
      uage:0,
      pnt:0,
      ismsgshow:true,
      ishidesetiing:false,
      vtid:1,
      
      items:[{mitemid:0,itemtp:0,cnt:"count 5"}],
    };
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
   
   getuseritems(){
  
 try {
         
	

         const userid = Usersession.getUserId();
      const  service ="/getuseritems?prd="+userid;
    
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
              
		const tdata = response.data;
		this.reducearr(tdata);
		
            })
            .catch((err: any) => {
            
            });

                
          }
        catch (e) {
            //debugger;
	
        }
    
   }
 reducearr(arr:any){
       //let data = JSON.stringify(arr);
       // alert(data);
	let farr = [
		{
		mitemid:0,itemtp:0,cnt:"count 0"
		},
		   ]

	 if(arr){
            
	     if(arr.length > 0){
              
		for(let i =0;i< arr.length;i++){
                 let obj = {mitemid:0,itemtp:0,cnt:"count 0"};
                 const rv = arr[i][0];
                
                 obj["mitemid"] = rv["mitemid"];
		obj["itemtp"] = rv["itemtp"];
		obj["cnt"] = 'count ' + rv["cnt"];
                
		 farr.push(obj);
		 
		}
	    }
	 }
	if(farr.length > 1){
	 farr.shift();
	}
       //userchats = farr;
       this.setState({ items: farr });
       // alert(JSON.stringify(farr));
     }

  
    componentDidMount() {
        debugger;
        
	this.getuseritems();
    }
 
 render() {

   
     return (
     <div style={{height:'93vh'}} className="c-pfp-line">

       <div>
	<div style={{height:'auto',width:'100%'}}>  
 	   
           <div style={{height:'93vh',overflowY:'auto'}}>
            
           {this.state.items.map((row,index)=>(
            <div style={{height:'auto'}} className="purchase-itm-nm">
		
             
	<div id="dvitem" style={{height:'20vh',width:'23vw'}} className="p-usr-itm-nm">
 		
	          <div className="per100" title={row.cnt}>  
  		      

			<Guseritem itemid={row.mitemid} itp={row.itemtp} />
			
	        	
		  </div>
		               

             	</div>
	
	    </div>
       ))}	


              		<div style={{display:'none',position:'relative'}} id="ushopitems" className="shopitems">  
	
	     		 </div>	
        </div> 


       </div> 

    </div>

	
  
 </div>
   
   
      );
}
}

